export const CAL_DEMO_LINK = 'problu/demo';
